<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 21.8999C12 21.2924 12.4925 20.7999 13.1 20.7999H21.9001C22.5076 20.7999 23.0001 21.2924 23.0001 21.8999C23.0001 22.5075 22.5076 22.9999 21.9001 22.9999H13.1C12.4925 22.9999 12 22.5075 12 21.8999Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.6511 7.70992C23.4219 5.93218 23.3467 3.59767 22.0245 2.16801C21.3797 1.47091 20.462 1.02563 19.4226 1.00107C18.3794 0.976435 17.2985 1.37539 16.3011 2.20983C16.2756 2.23117 16.2511 2.25365 16.2277 2.27722L1.96191 16.5997C1.34588 17.2182 1 18.0556 1 18.9285V20.7914C1 22.003 1.98118 23 3.20423 23H5.05095C5.92845 23 6.76982 22.6505 7.38907 22.0288L21.6511 7.70992ZM17.728 5.17224C17.2984 4.74267 16.6019 4.74267 16.1723 5.17224C15.7428 5.60182 15.7428 6.2983 16.1723 6.72788L17.2723 7.82788C17.7019 8.25745 18.3984 8.25745 18.828 7.82788C19.2575 7.39829 19.2575 6.70182 18.828 6.27224L17.728 5.17224Z"
      fill="currentColor"
    />
  </svg>
</template>
